import React, { useState } from 'react';
import { Mail, Phone, Settings } from 'lucide-react';
import '@fontsource-variable/geist/wght.css';
import CxEmailSendMailModal from '../../customer-experience/components/CxEmailSendMailModal';
import CustomersPhonesModal from './CustomersPhonesModal';
import { useCxExpToast } from '../../customer-experience/components/CxExpSonnerToast';
import '../../process-config/ConfigStatusView2.css';
import '../../customer-experience/components/CxEmailSendMailModal.css';
import '../../customer-experience/components/CxEmailTemplateModal.css';
import './CustomersEmailConfig.css';

function Pcs2Section({ icon: Icon, title, desc, children, className = '' }) {
  return (
    <section className={['pcs2-section', className].filter(Boolean).join(' ')}>
      <div className="pcs2-section-aside">
        <div className="pcs2-section-heading">
          <Icon size={16} strokeWidth={1.75} aria-hidden />
          <h3 className="pcs2-section-title">{title}</h3>
        </div>
        {desc ? <p className="pcs2-section-desc">{desc}</p> : null}
      </div>
      <div className="pcs2-section-body">{children}</div>
    </section>
  );
}

function Pcs2Subblock({ title, desc, action }) {
  return (
    <div className="pcs2-subblock">
      <div className={`pcs2-subhead${action ? ' pcs2-subhead--with-action' : ''}`}>
        <div className="pcs2-subhead-copy">
          {title ? <h4 className="pcs2-subtitle">{title}</h4> : null}
          {desc ? <p className="pcs2-subdesc">{desc}</p> : null}
        </div>
        {action ? <div className="pcs2-subhead-action">{action}</div> : null}
      </div>
    </div>
  );
}

function Pcs2TooltipHost({ text, children, align = 'start' }) {
  if (!text) return children;
  return (
    <span
      className={[
        'pcs2-tooltip-host',
        align === 'end' ? 'pcs2-tooltip-host--align-end' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      data-tooltip={text}
    >
      {children}
    </span>
  );
}

export default function CustomersEmailConfig() {
  const { success: toastSuccess, Toaster } = useCxExpToast();
  const [mailModalOpen, setMailModalOpen] = useState(false);
  const [phonesModalOpen, setPhonesModalOpen] = useState(false);

  return (
    <div className="pcs2-page customers-email-page">
      <Pcs2Section
        className="customers-email-section"
        icon={Mail}
        title="E-mail"
        desc="Configuração de e-mail padrão de envio"
      >
        <Pcs2Subblock
          title="E-mail padrão de envio"
          desc="Configure os e-mails que o sistema utilizará para enviar as pesquisas"
          action={(
            <Pcs2TooltipHost text="Configurar e-mail de envio" align="end">
              <button
                type="button"
                className="pcs2-btn-gear"
                aria-label="Configurar e-mail de envio"
                onClick={() => setMailModalOpen(true)}
              >
                <Settings size={15} strokeWidth={1.75} />
              </button>
            </Pcs2TooltipHost>
          )}
        />
      </Pcs2Section>

      <Pcs2Section
        className="customers-email-section customers-phones-section"
        icon={Phone}
        title="Telefones"
        desc="Telefone e WhatsApp de contato por empresa"
      >
        <Pcs2Subblock
          title="Telefones por empresa"
          desc="Configure telefone e WhatsApp (10 ou 11 dígitos) de cada empresa"
          action={(
            <Pcs2TooltipHost text="Configurar telefones" align="end">
              <button
                type="button"
                className="pcs2-btn-gear"
                aria-label="Configurar telefones"
                onClick={() => setPhonesModalOpen(true)}
              >
                <Settings size={15} strokeWidth={1.75} />
              </button>
            </Pcs2TooltipHost>
          )}
        />
      </Pcs2Section>

      <CxEmailSendMailModal
        open={mailModalOpen}
        onClose={() => setMailModalOpen(false)}
        onSaved={() => toastSuccess('Configurações de e-mail salvas.')}
      />
      <CustomersPhonesModal
        open={phonesModalOpen}
        onClose={() => setPhonesModalOpen(false)}
        onSaved={() => toastSuccess('Telefones salvos.')}
      />
      {Toaster}
    </div>
  );
}
